import Vue from "vue";
import Component from "vue-class-component";
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import FormResStatus from '@/api/form-res-status';
import REQ_URL from '@/consts/req-url';
import { ResData } from '@/types/response-data';

@Component({
    mixins: [validationMixin],
    props: {
        open: Boolean
    },
    validations: {
        formData: {
            fio: { required },
            email: { required, email },
            msg: { required }
        }
    },
})
export default class Feedback extends Vue {
    formStatus = new FormResStatus()
    formData = {
        fio: '',
        email: '',
        tel: '',
        theme: '',
        msg: ''
    }
    close() {
        this.$emit('update:open', false)
    }
    async submit() {
        this.$v.$touch();
        if (!this.$v.$error) {
            try {
                let data = await this.$fetch<ResData<any>>(REQ_URL.FEEDBACK, {
                    method: 'POST',
                    body: JSON.stringify(this.formData),
                    credentials: 'same-origin'
                }, this.formStatus)

                if (data.msg) {
                    (this.$refs.form as any).reset()
                    this.$emit('update:open', false)
                    this.$v.$reset();
                    this.$store.commit('modal:open', {
                        type: 'success',
                        msg: data.msg
                    })

                }
                else throw new Error(data.error)
            } catch (error) {
                console.error(error.message)
            }

            this.formStatus.pending = false;

        }
    }
}